import React from 'react';

const CONTACT_INFO = [
  {
    label: 'Email',
    value: 'raghavsharma.070901@gmail.com',
    href: 'mailto:raghavsharma.070901@gmail.com',
  },
  {
    label: 'LinkedIn',
    value: 'linkedin.com/in/raghav-sharma',
    href: 'https://www.linkedin.com/in/raghav-sharma-8a126434b/',
  },
];

export default function Contact() {
  return (
    <section id="contact" className="panel">
      <h3>Contact</h3>
      <div className="contact-info">
        {CONTACT_INFO.map((item) => (
          <a
            key={item.label}
            href={item.href}
            target={item.href.startsWith('http') ? '_blank' : undefined}
            rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
            className="contact-item"
          >
            <span className="contact-label">{item.label}</span>
            <span className="contact-value">{item.value}</span>
          </a>
        ))}
      </div>
    </section>
  );
}

